import React from 'react'
import '../Destination/Destination.css'
import DestinationOffer from '../DestinationOffer/DestinationOffer'
import { FaArrowRight } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import Why from '../Why/Why'
import WhyChoose from '../WhyChoose/WhyChoose'

const Destination = () => {
  return (
    <>
      <div className="post-d-dc">
        <div className="overlay-d-dc">
        {/*-
          <div className="hero-badge-dc">
            <span>🌍 Explore the World</span>
          </div>
          --*/}
          <h1 className="text-d-dc">
            For Perfect Holidays
           {/*- <span className="highlight-dc">Awaits</span>--*/}
          </h1>
          {/*--
          <p className="hero-subtitle-dc">
            Discover handpicked destinations and create unforgettable memories. 
            Your next adventure starts here.
          </p>
          --*/}
          <Link to="/contactus">
          <button className="hero-cta-dc">
            Contact Now
            <FaArrowRight />
          </button>
          </Link>
        </div>
      </div>
      <DestinationOffer/>
      <WhyChoose/>
    </>
  )
}

export default Destination